import R, { useRef as d, useState as C, useEffect as m, useCallback as x, useMemo as j, createContext as B, useContext as W } from "react";
import { z as k } from "./index2.js";
function I(r, t) {
  var e = d(null), i = d(null);
  i.current = t;
  var n = d(null);
  m(function() {
    o();
  });
  var o = x(function() {
    var u = n.current, a = i.current, c = u || (a ? a instanceof Element ? a : a.current : null);
    e.current && e.current.element === c && e.current.subscriber === r || (e.current && e.current.cleanup && e.current.cleanup(), e.current = {
      element: c,
      subscriber: r,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: c ? r(c) : void 0
    });
  }, [r]);
  return m(function() {
    return function() {
      e.current && e.current.cleanup && (e.current.cleanup(), e.current = null);
    };
  }, []), x(function(u) {
    n.current = u, o();
  }, [o]);
}
function p(r, t, e) {
  return r[t] ? r[t][0] ? r[t][0][e] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    r[t][e]
  ) : t === "contentBoxSize" ? r.contentRect[e === "inlineSize" ? "width" : "height"] : void 0;
}
function M(r) {
  r === void 0 && (r = {});
  var t = r.onResize, e = d(void 0);
  e.current = t;
  var i = r.round || Math.round, n = d(), o = C({
    width: void 0,
    height: void 0
  }), u = o[0], a = o[1], c = d(!1);
  m(function() {
    return c.current = !1, function() {
      c.current = !0;
    };
  }, []);
  var f = d({
    width: void 0,
    height: void 0
  }), l = I(x(function(h) {
    return (!n.current || n.current.box !== r.box || n.current.round !== i) && (n.current = {
      box: r.box,
      round: i,
      instance: new ResizeObserver(function(v) {
        var g = v[0], w = r.box === "border-box" ? "borderBoxSize" : r.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", y = p(g, w, "inlineSize"), S = p(g, w, "blockSize"), s = y ? i(y) : void 0, b = S ? i(S) : void 0;
        if (f.current.width !== s || f.current.height !== b) {
          var z = {
            width: s,
            height: b
          };
          f.current.width = s, f.current.height = b, e.current ? e.current(z) : c.current || a(z);
        }
      })
    }), n.current.instance.observe(h, {
      box: r.box
    }), function() {
      n.current && n.current.instance.unobserve(h);
    };
  }, [r.box, i]), r.ref);
  return j(function() {
    return {
      ref: l,
      width: u.width,
      height: u.height
    };
  }, [l, u.width, u.height]);
}
function _(r, t) {
  return function(e) {
    if (Array.isArray(e))
      return e;
  }(r) || function(e, i) {
    var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (n != null) {
      var o, u, a, c, f = [], l = !0, h = !1;
      try {
        if (a = (n = n.call(e)).next, i === 0) {
          if (Object(n) !== n)
            return;
          l = !1;
        } else
          for (; !(l = (o = a.call(n)).done) && (f.push(o.value), f.length !== i); l = !0)
            ;
      } catch (v) {
        h = !0, u = v;
      } finally {
        try {
          if (!l && n.return != null && (c = n.return(), Object(c) !== c))
            return;
        } finally {
          if (h)
            throw u;
        }
      }
      return f;
    }
  }(r, t) || function(e, i) {
    if (e) {
      if (typeof e == "string")
        return E(e, i);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
        return Array.from(e);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return E(e, i);
    }
  }(r, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function E(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, i = new Array(t); e < t; e++)
    i[e] = r[e];
  return i;
}
var A = B({ containerWidth: void 0 }), G = function() {
  return W(A);
};
function O(r) {
  var t = r.children, e = _(C(), 2), i = e[0], n = e[1], o = M({ onResize: function(u) {
    var a = u.width;
    n(a);
  } }).ref;
  return R.createElement(A.Provider, { value: { containerWidth: i } }, R.createElement("div", { style: { width: "100%" }, ref: o }, t));
}
O.displayName = "LeafyGreenChatProvider", O.propTypes = { children: k.node };
export {
  G as c,
  O as f
};
